import React from "react";

import "react-tagsinput/react-tagsinput.css";
import * as UIConstants from "../UIConstants";
import { InputGroup } from "react-bootstrap";
import Select from "react-select";

import "react-select/dist/react-select.css";
//import { fromByteArray } from "ipaddr.js";

class RequestContact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultRequestContacts: this.props.requestContacts, //Contacts par defaut (issus de l'envoi précédent)
      contacts: this.props.contacts, //Tous les contacts issus de la base de données
      contactOptions: [], //Contacts additionnels
      selectedContacts: [], //Contacts sélectionnés ????
    };
  }
  //LifCycle
  componentDidMount() {
    this.buildRequestContacts();
    this.forceUpdate();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.isDiff(this.props.requestContacts, nextProps.requestContacts) ||
      this.isDiff(this.props.contacts, nextProps.contacts)
    ) {
      this.setState({
        contacts: nextProps.contacts,
        defaultRequestContacts: nextProps.requestContacts,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.isDiff(this.props.requestContacts, nextProps.requestContacts) ||
      this.isDiff(this.props.contacts, nextProps.contacts) ||
      this.isDiff(this.state.selectedContacts, nextState.selectedContacts)
    );
  }

  isDiff(array1, array2) {
    if (array1 && array2) {
      if (array1.length !== array2.length) {
        return true;
      }
      var shouldUpdate = false;
      for (var i = 0; i < array1.length; i++) {
        if (array2.filter((e) => e.email === array1[i].email).length === 0) {
          shouldUpdate = true;
          break;
        }
      }

      return shouldUpdate;
    } else if (!array1 && array2) {
      return true;
    }

    return false;
  }

  //Contact Manager
  getContacts = () => {
    return this.props.contacts;
  };

  handleSelectChange = (options) => {
    //console.log("handleSelectChange", options);
    this.setState({ selectedContacts: options });
    this.props.setContacts(options); //Propage au parent
  };

  isValidNewOptionHandler = (value) => {
    var matches = UIConstants.EMAIL_VALIDATION_REGEX.exec(value.label);
    return matches !== null;
  };

  newOptionCreatorHandler = (option, labelKey, labelValue) => {
    return { label: option.label, value: null };
  };

  buildRequestContacts = () => {
    var selectedContacts = this.state.defaultRequestContacts.map(
      (contact, index) => {
        return { label: contact.email, value: contact.id };
      }
    );
    this.setState({ selectedContacts: selectedContacts }, function () {
      this.props.setContacts(this.state.selectedContacts);
    });
  };

  render() {
    //this.buildOtherContacts();
    var contactOptions = this.state.contactOptions;

    if (null !== this.state.contacts) {
      contactOptions = [];

      for (var i = 0; i < this.state.contacts.length; i++) {
        var contact = this.state.contacts[i];

        var alreadyExists = false;
        for (var j = 0; j < this.state.selectedContacts.length; j++) {
          if (this.state.selectedContacts[j].label === contact.email) {
            alreadyExists = !alreadyExists;
            break;
          }
        }

        if (!alreadyExists) {
          contactOptions.push({ label: contact.email, value: contact.id });
        }
      }
    }
    
    return (
      <InputGroup style={{ zIndex: 6 }}>
        <InputGroup.Addon>
          <i className="fa fa-envelope" />
        </InputGroup.Addon>
        <Select.Creatable
          closeOnSelect={false}
          disabled={false}
          multi
          value={this.state.selectedContacts}
          onChange={(value) => this.handleSelectChange(value)}
          options={contactOptions}
          isValidNewOption={(label) => this.isValidNewOptionHandler(label)}
          newOptionCreator={(label, labelKey, valueKey) =>
            this.newOptionCreatorHandler(label, labelKey, valueKey)
          }
        />
      </InputGroup>
    );
  }
}

export default RequestContact;



// WEBPACK FOOTER //
// ./src/components/UI/Widget/RequestContact.js